export default __webpack_public_path__ + "static/media/background_placeholder_event.67485eeb.svg";